export default defineNuxtPlugin((nuxtApp) => {
  onNuxtReady(() => {
    let currentGtmEvent = 0

    nuxtApp.hook('page:finish', () => {
      // Remove detached DOM elements from Gtm events
      // Detached DOM elements inside Gtm events causes huge memory leaks
      const events = (window?.dataLayer || []) as { 'gtm.element': HTMLElement | undefined }[]
      for (let i = currentGtmEvent; i < events.length; i++) {
        const event = events[i]
        if (event && event['gtm.element'] && !document.contains(event['gtm.element'])) {
          event['gtm.element'] = undefined
        }
      }
      if (events.length) {
        currentGtmEvent = events.length
      }
    })
  })
})
